import { configureStore, ThunkAction, Action } from "@reduxjs/toolkit";
import counterReducer from "./slices/counter";
import userReducer from "./slices/user";
import userAssociationReducer from "./slices/userAssociation";
import roadReducer from "./slices/road";
import propertyReducer from "./slices/property";
import accountingReducer from "./slices/accounting";
import associationReducer from "./slices/association";
import conversationReducer from "./slices/conversation";
import fileReducer from "./slices/file";
import invoiceReducer from "./slices/invoice";
import meetingReducer from "./slices/meeting";
import meetingInviteReducer from "./slices/meetingInvite";
import membershipReducer from "./slices/membership";
import subscriptionReducer from "./slices/subscription";
import planReducer from "./slices/plan";
import subscriptionInvoiceReducer from "./slices/subscriptionInvoice";
import uiReducer from "./slices/ui";
import noticeReducer from "./slices/notice";
import noticeDeliveryReducer from "./slices/noticeDelivery";
import propertyCandidatesReducer from "./slices/propertyCandidates";
import superadminGdprReducer from "./slices/superadminGdpr";
import letterDispatchReducer from "./slices/letterDispatch";
import postalInvoiceReducer from "./slices/postalInvoice";
import notificationsReducer from "./slices/notifications";
import mapMarkingsReducer from "./slices/mapMarkings";

export const store = configureStore({
  reducer: {
    counter: counterReducer,
    user: userReducer,
    userAssociation: userAssociationReducer,
    road: roadReducer,
    property: propertyReducer,
    accounting: accountingReducer,
    association: associationReducer,
    conversation: conversationReducer,
    file: fileReducer,
    invoice: invoiceReducer,
    meeting: meetingReducer,
    meetingInvite: meetingInviteReducer,
    membership: membershipReducer,
    subscription: subscriptionReducer,
    plan: planReducer,
    subscriptionInvoice: subscriptionInvoiceReducer,
    ui: uiReducer,
    notice: noticeReducer,
    noticeDelivery: noticeDeliveryReducer,
    propertyCandidates: propertyCandidatesReducer,
    superadminGdpr: superadminGdprReducer,
    letterDispatch: letterDispatchReducer,
    postalInvoice: postalInvoiceReducer,
    notifications: notificationsReducer,
    mapMarkings: mapMarkingsReducer,
  },
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;
